module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_question-b47c29fc19fa02c833871e8971a58659.svg";